import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

import { getIsLoggedIn } from '../../auth/utils/getIsLoggedIn'
import { publicationApi } from '../api/publicationApi'

const favoritePublicationsOptions = (limit = 10, offset = 0) =>
  infiniteQueryOptions({
    queryKey: ['favorite_publications', limit, offset],
    enabled: !!getIsLoggedIn(),
    queryFn: ({ signal, pageParam }) => publicationApi.getFavoritePublications({ ...pageParam }, { signal }),
    initialPageParam: {
      limit,
      offset,
    },
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.length === lastPageParam.limit
        ? { offset: lastPageParam.offset + lastPageParam.limit, limit: lastPageParam.limit }
        : null,
    select: (data) => {
      return data.pages.flat()
    },
    retry: 0,
  })

export const useFavoritePublicationsQuery = (limit = 10, offset = 0) =>
  useInfiniteQuery(favoritePublicationsOptions(limit, offset))
